// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"2d287b01","60":"2d287b01","145":"2d287b01","171":"398f96fe","323":"2d287b01","326":"2d287b01","480":"2d287b01","778":"2d287b01"}[chunkId] + ".chunk.css";
};